export const CREATE_PROSPECTS = 'legend/prospect/CREATE_PROSPECTS';
export const CREATE_PROSPECTS_FAIL = 'legend/prospect/CREATE_PROSPECTS_FAIL';
export const CREATE_PROSPECTS_SUCCESS = 'legend/prospect/CREATE_PROSPECTS_SUCCESS';
export const CLEAR_PROSPECT = 'legend/prospect/CLEAR_PROSPECT';

export const GET_QUESTIONS = 'legend/prospect/GET_QUESTIONS';
export const GET_QUESTIONS_FAIL = 'legend/prospect/GET_QUESTIONS_FAIL';
export const GET_QUESTIONS_SUCCESS = 'legend/prospect/GET_QUESTIONS_SUCCESS';

export const GET_REGISTER_DATA = 'legend/prospect/GET_REGISTER_DATA';
export const GET_REGISTER_DATA_FAIL = 'legend/prospect/GET_REGISTER_DATA_FAIL';
export const GET_REGISTER_DATA_SUCCESS = 'legend/prospect/GET_REGISTER_DATA_SUCCESS';

